import React from 'react'

import { useBrandTheme } from 'services/Branding/hooks'

import type { CourseValueType } from '../../CourseKitTypes'
import { CourseOptionLabel, getTextFromReactElement } from '../../CourseKitUtils'
import { useMenuItemIsHovered, useMenuItemIsSelected, useSetHovered } from '../MenuContext'
import StyledCourseMenuItem from '../styled/StyledCourseMenuItem'
import type { ICourseMenuItem } from './types'

const CourseMenuItem = <T extends CourseValueType>({
  item,
  onClick,
  isFocused,
}: ICourseMenuItem<T>) => {
  const { disabled, hidden } = item
  const theme = useBrandTheme()
  const setHovered = useSetHovered()
  const isHovered = useMenuItemIsHovered(item.value)
  const isSelected = useMenuItemIsSelected(item.value)
  const handleClick = () => !disabled && onClick?.(item)
  const onMouseMove = () => setHovered?.(item)

  const getTextLabel = () => {
    if (typeof item.label === 'string') {
      return item.label
    }

    if (typeof item.label === 'number') {
      return item.label.toString()
    }

    if (typeof item.label === 'function') {
      const Label = item.label
      return getTextFromReactElement(<Label />)
    }

    return undefined
  }

  if (hidden) {
    return null
  }
  //use styled components here
  return (
    <StyledCourseMenuItem
      $disabled={!!disabled}
      $hovered={!!isHovered}
      $isFocused={!!isFocused}
      $selected={isSelected}
      $theme={theme}
      aria-label={getTextLabel()}
      aria-selected={isSelected}
      id={String(item.id)}
      onClick={handleClick}
      onMouseMove={onMouseMove}
      role='option'
      tabIndex={-1}
    >
      {item.icon}
      <CourseOptionLabel option={item} />
    </StyledCourseMenuItem>
  )
}

export default CourseMenuItem
